import { StatusCodes } from "http-status-codes";
import {
  IAllCompleteHealthCare,
  IBillingUrlFormResponse,
  IHealthCare,
  IHealthCareDoctorForm,
  IHealthCareRequiredDocument,
  IHealthCareScheme,
  IManageUserForm,
  IPatchHealthCareScheme,
  IPostBillingUrlFormResponse,
  IPostHealthCareDoctorResponse,
  IPostManageUserResponse,
  IPostSchemeSpecificLoginDetailsResponse,
  ISchemeSpecificLoginDetailsForm,
} from "../../interfaces/IHealthCare";
import Axios from "../../utils/axiosInterceptor";
import { HEALTH_CARE_APIS } from "../../utils/constants";

export const modifyHealthCareDetails = async (
  id: number,
  formData: IHealthCare
): Promise<IAllCompleteHealthCare> => {
  try {
    const response = await Axios.patch(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${id}`,
      formData
    );

    if (response.status === StatusCodes.OK) {
      return {
        healthCareRes: response.data.healthCare,
        status: response.status,
      };
    } else {
      return {
        errorMessage: "Cannot update health care details",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error updating health care details:", error);
    throw new Error("Cannot update health care details");
  }
};

export const modifyHealthCareScheme = async (
  healthCareId: number,
  id: number,
  schemeId: number,
  formData: IHealthCareScheme
): Promise<IPatchHealthCareScheme> => {
  try {
    const response = await Axios.patch<IHealthCareScheme>(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/schemes/${schemeId}/health_care_schemes/${id}`,
      formData
    );

    if (response.status === StatusCodes.ACCEPTED) {
      return {
        updatedHealthCareScheme: response.data,
        status: response.status,
      };
    } else {
      return {
        errorMessage: "Cannot update health care scheme",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error updating health care scheme:", error);
    throw new Error("Cannot update health care scheme");
  }
};

export const modifyHealthCareDoctor = async (
  healthCareId: number,
  id: number,
  formData: IHealthCareDoctorForm
): Promise<IPostHealthCareDoctorResponse> => {
  try {
    const response = await Axios.patch<IHealthCareDoctorForm>(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_doctors/${id}`,
      formData
    );

    if (response.status === StatusCodes.OK) {
      return {
        doctorRes: response.data,
        status: response.status,
      };
    } else {
      return {
        errorMessage: "Cannot update health care doctor",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error updating health care doctor:", error);
    throw new Error("Cannot update health care doctor");
  }
};

export const modifyManageUser = async (
  healthCareId: number,
  id: number,
  formData: IManageUserForm
): Promise<IPostManageUserResponse> => {
  try {
    const response = await Axios.patch<IManageUserForm>(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_management_user/${id}`,
      formData
    );

    if (response.status === StatusCodes.OK) {
      return {
        manageUserRes: response.data,
        status: response.status,
      };
    } else {
      return {
        errorMessage: "Cannot update manage user",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error updating manage user:", error);
    throw new Error("Cannot update manage user");
  }
};

export const modifySchemeSpecificLoginDetails = async (
  healthCareId: number,
  id: number,
  formData: ISchemeSpecificLoginDetailsForm
): Promise<IPostSchemeSpecificLoginDetailsResponse> => {
  try {
    const response = await Axios.patch<ISchemeSpecificLoginDetailsForm>(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_mis_credentials_scheme_specific/${id}`,
      formData
    );

    if (response.status === StatusCodes.OK) {
      return {
        schemeSpecificLoginDetailsRes: response.data,
        status: response.status,
      };
    } else {
      return {
        errorMessage: "Cannot update scheme specific login details",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error updating  scheme specific login details:", error);
    throw new Error("Cannot update  scheme specific login details");
  }
};

export const modifyBillingUrlForm = async (
  healthCareId: number,
  id: number,
  formData: IBillingUrlFormResponse
): Promise<IPostBillingUrlFormResponse> => {
  try {
    const response = await Axios.patch<IBillingUrlFormResponse>(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_billing_credentials/${id}`,
      formData
    );

    if (response.status === StatusCodes.OK) {
      return {
        billingUrlFormRes: response.data,
        status: response.status,
      };
    } else {
      return {
        errorMessage: "Cannot update billing url form",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error updating billing url form:", error);
    throw new Error("Cannot update billing url form");
  }
};

export const modifyHealthCareRequiredDocument = async (
  healthCareId: number,
  formData: IHealthCareRequiredDocument
): Promise<IAllCompleteHealthCare> => {
  try {
    const response = await Axios.put(
      `${HEALTH_CARE_APIS.ADD_HEALTHCARE}/${healthCareId}/health_care_required_documents`,
      formData
    );

    if (response.status === StatusCodes.OK) {
      return {
        healthCareRequiredDocumentsRes:
          response.data.healthCareRequiredDocuments,
        status: response.status,
      };
    } else {
      return {
        errorMessage: "Cannot update health care required document",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error updating health care required document:", error);
    throw new Error("Cannot update health care required document");
  }
};
